/* eslint no-unused-vars: 0 */

/**
 * This file was automatically generated by ruby_to_typescript.rake.
 * Do not modify it by hand.
 */
export enum UserRequestPreferenceSource {
  UNKNOWN = "Unknown",
  EMAIL = "Email",
  PREFERENCE_MODAL = "PreferenceModal",
  MARKETPLACE_CARD = "MarketplaceCard",
  FOLLOWED_NOTIFICATION = "FollowedNotification",
  REQUEST_PAGE = "RequestPage",
  INTERNAL = "Internal",
}
